// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2lCmf","footer":"ModalError_footer__1AGpv"};